module.exports = __webpack_public_path__ + "media/images/pc/stores/fukuoka/fukuoka_concept_02-c2964144301c39f193860bc93cbe18ba.jpg";